import { render, staticRenderFns } from "./customGroup.vue?vue&type=template&id=298ce754&scoped=true"
import script from "./customGroup.vue?vue&type=script&lang=js"
export * from "./customGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298ce754",
  null
  
)

export default component.exports